import React, { memo } from 'react';

import { Drawer } from 'ui-components/components/drawer/drawer';

import { ForecastingDataProvider } from './context/forecasting-data-context';
import { ForecastingSettingsProvider } from './context/forecasting-settings-provider';
import { ForecastingDrawerContainer } from './forecasting-drawer-container';
import style from './styles.module.less';

/**
 * ForecastingDrawer component that displays inventory forecasting data and filters
 * @param {object} props - Component props
 * @param {() => void} props.onClose - Callback function when the drawer is closed
 * @param {string[]} props.selectedProductIds - Array of selected product IDs to filter by
 * @param {string} [props.inventoryWarehouseId] - Optional warehouse ID to filter inventory entities
 * @returns {React.ReactElement} The rendered ForecastingDrawer component
 */
const ForecastingDrawer = ({ onClose, selectedProductIds = [], inventoryWarehouseId }) => {
  return (
    <Drawer className={style['forecasting-drawer']} onCancel={onClose} onClose={onClose}>
      <ForecastingSettingsProvider>
        <ForecastingDataProvider inventoryWarehouseId={inventoryWarehouseId} selectedProductIds={selectedProductIds}>
          <ForecastingDrawerContainer onClose={onClose} />
        </ForecastingDataProvider>
      </ForecastingSettingsProvider>
    </Drawer>
  );
};

export default memo(ForecastingDrawer);
